import { render, staticRenderFns } from "./WebComponentErrorPausedCode.vue?vue&type=template&id=fc6b8d92&shadow"
import script from "./WebComponentErrorPausedCode.vue?vue&type=script&lang=ts&setup=true&shadow"
export * from "./WebComponentErrorPausedCode.vue?vue&type=script&lang=ts&setup=true&shadow"
function injectStyles (context) {
  
  var style0 = require("./WebComponentErrorPausedCode.vue?vue&type=style&index=0&id=fc6b8d92&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports